import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import IhrStressfreierUmzugInHamburg from "./sections/IhrStressfreierUmzugInHamburg";
import OurPavingLandscapingExpertise from "./sections/OurPavingLandscapingExpertise";
import OurCollaborativeJourney from "./sections/OurCollaborativeJourney";
import The4ElevenMethodology from "./sections/The4ElevenMethodology";
import IndustriesWeHelp from "./sections/IndustriesWeHelp";
import TheBakeryStory from "./sections/TheBakeryStory";
import ExpandOurNetwork from "./sections/ExpandOurNetwork";
import RequestQuote from "./sections/RequestQuote";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <IhrStressfreierUmzugInHamburg />
      <OurPavingLandscapingExpertise />
      <OurCollaborativeJourney />
      <The4ElevenMethodology />
      <IndustriesWeHelp />
      <TheBakeryStory />
      <ExpandOurNetwork />
      <RequestQuote />
      <Footer />
    </div>;
}